module.exports = __webpack_public_path__ + "ls.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ls.svg
// module id = 921
// module chunks = 0